module.exports = __webpack_public_path__ + "static/media/water-hex.2aa21c7f.png";